import { userAxios } from "../index";
import { Observable } from 'rxjs'

const patientList = async (perPage) => {
    try {
        return await userAxios.get(`users/patients/all/${perPage}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientDetail = async (id) => {
    try {
        return await userAxios.get(`users/patients/${id}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientCreate = async (data) => {
    try {
        return await userAxios.post('users/patients', data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientUpdate = async (id, data) => {
    try {
        return await userAxios.put(`users/patients/${id}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientDelete = async (id) => {
    try {
        return await userAxios.delete(`users/patients/${id}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientPagination = async (perPage, paginate) => {
    try {
        return await userAxios.get(`users/patients/all/${perPage}?page=${paginate}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientFilter = async (perPage, data) => {
    try {
        return await userAxios.post(`users/patients/search/${perPage}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const patientFilterPagination = async (perPage, paginate, data ) => {
    try {
        return await userAxios.post(`users/patients/search/${perPage}?page=${paginate}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const referencePagination = async (perPage, paginate) => {
    try {
        return await userAxios.get(`references/all/${perPage}?page=${paginate}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const referenceFilter = async (perPage, data) => {
    try {
        return await userAxios.post(`references/search/${perPage}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const normalizeListResponse = response => {
    if (!response) return { items: [], total: 0, current_page: 1, from: 1, to: 0 }
    const data = response.data
    const items = Array.isArray(data)
        ? data
        : (data && Array.isArray(data.data) ? data.data : [])

    const total = response.total ?? (data && data.total) ?? items.length ?? 0
    const current_page = response.current_page ?? (data && data.current_page) ?? 1
    const from = response.from ?? (data && data.from) ?? 1
    const to = response.to ?? (data && data.to) ?? (items.length ? items.length : 0)
    return { items, total, current_page, from, to }
}

const isActiveFilterValue = value => {
    if (value === null || value === undefined) return false
    if (typeof value === 'string' && value.trim() === '') return false
    if (Array.isArray(value)) return value.length > 0
    return true
}

const hasActiveFilters = filters => {
    if (!filters || typeof filters !== 'object') return false
    return Object.values(filters).some(isActiveFilterValue)
}

/**
 * Exporta pacientes para Excel con carga progresiva.
 *
 * Emite eventos:
 * - { type: 'progress', page, totalPages, totalCount, fetchedCount }
 * - { type: 'complete', patients, totalCount }
 */
const exportPatientsProgressive = (filters = {}, { batchSize = 500 } = {}) => {
    return new Observable(subscriber => {
        const perPage = batchSize
        const activeFilters = hasActiveFilters(filters)

        // Permite cancelar desde el componente al hacer unsubscribe.
        let cancelled = false
        subscriber.add(() => {
            cancelled = true
        })

        const fetchPatientsPage = async page => {
            if (activeFilters) {
                // POST search + page query param (misma forma que ya usa la tabla)
                const payload = filters || {}
                return userAxios
                    .post(`users/patients/search/${perPage}?page=${page}`, payload)
                    .then(res => res.data)
            }

            return userAxios
                .get(`users/patients/all/${perPage}?page=${page}`)
                .then(res => res.data)
        }

        const run = async () => {
            try {
                const firstResp = await fetchPatientsPage(1)
                const first = normalizeListResponse(firstResp)

                const totalCount = Number(first.total || 0) || 0
                const totalPages =
                    totalCount > 0 ? Math.ceil(totalCount / perPage) : 1

                const allPatients = [...first.items]

                subscriber.next({
                    type: 'progress',
                    page: 1,
                    totalPages,
                    totalCount,
                    fetchedCount: allPatients.length,
                })

                for (let page = 2; page <= totalPages; page++) {
                    if (cancelled) return
                    const resp = await fetchPatientsPage(page)
                    const pageData = normalizeListResponse(resp)

                    allPatients.push(...pageData.items)

                    subscriber.next({
                        type: 'progress',
                        page,
                        totalPages,
                        totalCount,
                        fetchedCount: allPatients.length,
                    })
                }

                subscriber.next({
                    type: 'complete',
                    patients: allPatients,
                    totalCount,
                })
                subscriber.complete()
            } catch (error) {
                subscriber.error(error)
            }
        }

        run()
    })
}

export default {
    patientList,
    patientDetail,
    patientCreate,
    patientUpdate,
    patientDelete,
    patientPagination,
    patientFilter,
    patientFilterPagination,
    referencePagination,
    referenceFilter,
    exportPatientsProgressive
}